// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IX5Y1{position:relative;background-color:#fff;height:500px;width:375px;padding:24px}.AdwLU{bottom:50%}`, "",{"version":3,"sources":["webpack://./src/pages/instamart/employee-login/Index.module.scss"],"names":[],"mappings":"AAAA,OACI,iBAAA,CACA,qBAAA,CACA,YAAA,CACA,WAAA,CACA,YAAA,CAGJ,OACI,UAAA","sourcesContent":[".container {\n    position: relative;\n    background-color: white;\n    height: 500px;\n    width: 375px;\n    padding: 24px;\n}\n\n.ssoLoginButton {\n    bottom: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `IX5Y1`,
	"ssoLoginButton": `AdwLU`
};
export default ___CSS_LOADER_EXPORT___;
